'use client';

import React from 'react';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { styles } from '.';
import Icon from '@repo/ui/icon';
import localFont from 'next/font/local';
import { toClassName } from 'helpers/format';

const manrope = localFont({
  src: '../../../../app/fonts/manrope.ttf',
  weight: '100 900',
});

type TProps = {
  locale: string;

  cta: {
    title: string;
    description: string;
    button: {
      label: string;
      link: {
        url: string;
        isExternal: boolean;
      };
    };
    image: {
      url: string;
    };
  };
};

const CTASection = (props: TProps) => {
  const { cta, locale } = props;

  const pathname = usePathname();

  if (
    pathname.includes('/jobs') ||
    pathname.includes('/join-the-family') ||
    pathname.includes('/contact')
  ) {
    return null;
  }

  //

  return (
    <div className={styles.container}>
      <Image
        src={cta.image.url}
        alt="cta-background"
        fill
        className={styles.image}
      />
      <div className={styles.content}>
        <h3 className={styles.title}>{cta?.title}</h3>
        <p
          className={toClassName(
            'opacity-50 text-sm sm:text-base',
            manrope.className,
          )}
        >
          {cta?.description}
        </p>
        <Link
          href={`/${locale}${cta?.button.link.url}`}
          className={styles.link}
          target={cta?.button?.link?.isExternal ? '_blank' : ''}
        >
          {cta?.button?.label}
          <Icon accessor="arrow-right" className="text-sm" />
        </Link>
      </div>
    </div>
  );
};

export default CTASection;
